import { Link } from "react-router-dom";
import { Mail, Clock, Snowflake } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useLang } from "@/i18n";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="main-footer" className="border-t border-sky-500/10 bg-[#04070C]">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 py-16 sm:grid-cols-2 sm:px-8 lg:grid-cols-4 lg:px-16">
        <div className="space-y-4">
          <Logo />
          <p className="max-w-xs text-sm leading-relaxed text-slate-400">{t("footer.tagline")}</p>
          <div className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-sky-500/70">
            <Snowflake size={13} /> {t("footer.nordic")}
          </div>
        </div>

        <div>
          <h4 className="font-display mb-4 text-sm font-bold uppercase tracking-[0.2em] text-slate-200">{t("footer.productCol")}</h4>
          <ul className="space-y-2.5 text-sm text-slate-400">
            <li><Link data-testid="footer-link-produit" to="/produit/nordiguard-sur-mesure" className="transition-colors hover:text-sky-400">{t("footer.mat")}</Link></li>
            <li><Link data-testid="footer-link-commander" to="/commander" className="transition-colors hover:text-sky-400">{t("footer.order")}</Link></li>
            <li><Link data-testid="footer-link-vehicule" to="/" className="transition-colors hover:text-sky-400">{t("footer.findVehicle")}</Link></li>
            <li><Link data-testid="footer-link-compat" to="/faq" className="transition-colors hover:text-sky-400">{t("footer.compat")}</Link></li>
            <li><Link data-testid="footer-link-policies" to="/politiques" className="transition-colors hover:text-sky-400">{t("footer.policies")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display mb-4 text-sm font-bold uppercase tracking-[0.2em] text-slate-200">{t("footer.companyCol")}</h4>
          <ul className="space-y-2.5 text-sm text-slate-400">
            <li><Link data-testid="footer-link-a-propos" to="/a-propos" className="transition-colors hover:text-sky-400">{t("nav.about")}</Link></li>
            <li><Link data-testid="footer-link-temoignages" to="/temoignages" className="transition-colors hover:text-sky-400">{t("nav.testimonials")}</Link></li>
            <li><Link data-testid="footer-link-faq" to="/faq" className="transition-colors hover:text-sky-400">{t("nav.faq")}</Link></li>
            <li><Link data-testid="footer-link-contact" to="/contact" className="transition-colors hover:text-sky-400">{t("nav.contact")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display mb-4 text-sm font-bold uppercase tracking-[0.2em] text-slate-200">{t("footer.contactCol")}</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex items-center gap-2.5">
              <Mail size={15} className="text-sky-400" />
              <a data-testid="footer-email-link" href="mailto:info@nordiguard.com" className="transition-colors hover:text-sky-400">info@nordiguard.com</a>
            </li>
            <li className="flex items-center gap-2.5">
              <Clock size={15} className="text-sky-400" />
              {t("footer.hours")}
            </li>
            <li className="text-xs text-slate-500">{t("footer.response")}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800/60 py-6 text-center text-xs text-slate-500">
        {t("footer.rights")}
      </div>
    </footer>
  );
};
